
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.667 4.667H6c-.733 0-1.333.6-1.333 1.333v6.667C4.667 13.4 5.267 14 6 14h6.667C13.4 14 14 13.4 14 12.667V6c0-.733-.6-1.333-1.333-1.333zm0 1.333v1.333H6V6h6.667zm-4 4V8.667H10V10H8.667zM10 11.333v1.334H8.667v-1.334H10zM7.333 10H6V8.667h1.333V10zm4-1.333h1.334V10h-1.334V8.667zM6 11.333h1.333v1.334H6v-1.334zm5.333 1.334v-1.334h1.334v1.334h-1.334zM4 11.333h-.667C2.6 11.333 2 10.733 2 10V3.333C2 2.6 2.6 2 3.333 2H10c.733 0 1.333.6 1.333 1.333V4H10v-.667H3.333V10H4v1.333z","fill":"currentColor"}})])
          )
        }
      }
    